import { Model } from "@vuex-orm/core";

export default class LicenceLimit extends Model {
  static get entity() {
    return "licence_limits";
  }
  static fields() {
    return {
      id: this.attr(null),
      licence_id: this.attr(null),
      name: this.attr(null),
      value: this.attr(null),
      status: this.attr(null),
    };
  }
}
